// import request from '@/utils/request'
// 获取全局的 axios 实例
let axiosInstance = null;

// 这个方法需要在 Vue 应用初始化后调用
export function setAxiosInstance3(axios) {
  axiosInstance = axios;
}

/**
 * 获取老师控制面板概览数据
 */
export function getTeacherOverview() {
  return axiosInstance({
    url: '/teacher-dashboard/overview',
    method: 'get'
  })
}

/**
 * 获取分数趋势数据
 * @param {Object} params 时间范围参数
 */
export function getScoreTrend(params) {
  return axiosInstance({
    url: '/teacher-dashboard/score-trend',
    method: 'post',
    data: params
  })
}

/**
 * 获取分数分布数据
 * @param {Number} examId 考试ID（可选）
 */
export function getScoreDistribution(examId) {
  const params = {}
  if (examId) {
    params.exam_id = examId
  }
  return axiosInstance({
    url: '/teacher-dashboard/score-distribution',
    method: 'get',
    params
  })
}

/**
 * 获取知识点分析数据
 * @param {Number} limit 限制数量
 */
export function getKnowledgeAnalysis(limit) {
  return axiosInstance({
    url: '/teacher-dashboard/knowledge-analysis',
    method: 'get',
    params: { limit }
  })
}

/**
 * 获取活跃度分析数据
 * @param {Object} params 时间范围参数
 */
export function getActivityAnalysis(params) {
  return axiosInstance({
    url: '/teacher-dashboard/activity-analysis',
    method: 'post',
    data: params
  })
}

/**
 * 获取单次考试详细分析
 * @param {Number} examId 考试ID
 */
export function getExamDetailedAnalysis(examId) {
  return axiosInstance({
    url: `/teacher-dashboard/exam-detailed-analysis/${examId}`,
    method: 'get'
  })
}